import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-footer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div>
      {{ 'footer.copyright' | translate: { year: currentYear } }}
      <ng-container *ngFor="let policy of policies; let last = last">
        <a *ngIf="policy.link"
           [href]="policy.link"
           target="_blank"
           rel="noopener">
          {{ policy.labelKey | translate }}
        </a>
        <span *ngIf="policy.link && !last"> - </span>
      </ng-container>
    </div>
  `,
  styles: []
})
export class CustomFooterComponent {
  readonly currentYear = new Date().getFullYear();
  readonly policies = [
    {
      link: 'https://www.tncid.app/privacy-policy-products-services',
      labelKey: 'footer.links.products'
    },
    {
      link: 'https://www.tncid.app/cookie-policy',
      labelKey: 'footer.links.cookie'
    },
    {
      link: 'https://www.tncid.app/privacy-policy-website',
      labelKey: 'footer.links.website'
    }
  ];
}
